import { render, staticRenderFns } from "./SlrcPL.vue?vue&type=template&id=2370c582"
import script from "./SlrcPL.vue?vue&type=script&lang=js"
export * from "./SlrcPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports